import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import NotFound from './NotFound';
import ErrorPage from './Error';

const ErrorView = () => {
  const error = useRouteError();

  console.log(error);
  console.log(isRouteErrorResponse(error)); // True

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <NotFound />
    );
  }

  return (
    <ErrorPage />
  );
};

export default ErrorView;
